import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import oracleHelper from "@/js/helper/oracle";
import wwwHiworksApi from "@/apis/www-hiworks-api"

Vue.use(Vuex)

const initialState = () => {
    return {
        packageGoods : [],
        checkedSubGoodsList : [],
        checkedClauseCompositionList : [],
        termPriceList : [],
        packageId: null,
        payTerm: null,
        termUnit: null,
        domain: null,
        domainMsg : null,
        domainStatus : null,
        totalPrice: 0,
        expireDate: null,
    }
}

const getters = {
    getMainGoodsId : state => {
        let mainPackageGoodsInfo = _.chain(state.packageGoods)
            .find(packageGoodsInfo => {
                return parseInt(packageGoodsInfo.sort_order) === 1
            })
            .value();

        if(!mainPackageGoodsInfo){
            return null
        }
        return parseInt(mainPackageGoodsInfo['goods_id'])
    },
    getOrderRequestInfo : (state, getters) => {
        let packageOrderRequestInfo = getters.getPackageOrderRequestInfo;
        const year = state.expireDate.getFullYear()
        let month = state.expireDate.getMonth() + 1
        if(month < 10){
            month = "0"+month
        }
        let date = state.expireDate.getDate()
        if(date < 10){
            date = "0"+date
        }

        let requestExpireDate = year + "-"+ month + "-" + date

        let checkout = {
            expire_date: requestExpireDate,
            payment: {
                total_price: getters.getTotalPrice
            },
            packages: [
                packageOrderRequestInfo
            ],
            domain_data: {
                domain: state.domain,
                key: null,
                status: state.domainStatus,
                ref_goods_term: null,
            }
        }

        return checkout
    },
    getPackageOrderRequestInfo : (state, getters) => {
        let orderInfoList = getters.getOrderInfoList
        let subGoodsOrderInfoList = getters.getSubGoodsOrderInfoList
        
        let packageOrderRequestInfo = {
            id: state.packageId,
            goods : []
        }

        orderInfoList.forEach(orderInfo => {
            let basePrice = 0
            basePrice += orderInfo.priceInfo.origin_price / orderInfo.priceInfo.term_volume
            basePrice += _.chain(subGoodsOrderInfoList)
                .filter(subGoodsOrderInfo => {
                    return !!subGoodsOrderInfo.perVolume
                })
                .sumBy(subGoodsOrderInfo => {
                    /**
                     * (1개월 별 정가) X (선택 volume / select Box Term) X 수량
                     */
                return subGoodsOrderInfo.priceInfo.origin_price / subGoodsOrderInfo.priceInfo.term_volume // (1개월 별 정가)
                    * (subGoodsOrderInfo.volume / subGoodsOrderInfo.perVolume)    // (선택 volume / select Box Term)
                    * subGoodsOrderInfo.quantity  // 수량
            })


            let subGoodsList = _.chain(subGoodsOrderInfoList)
                .filter(subGoodsOrderInfo => {
                    return subGoodsOrderInfo.main_goods_id === orderInfo.id
                })
                .flatMap(subGoodsOrderInfo => {
                    return {
                        id: subGoodsOrderInfo.id,
                        quantity: subGoodsOrderInfo.quantity,
                        volume: subGoodsOrderInfo.volume,
                    }
                })
                .value()


            let goodsInfo = {
                id: orderInfo.id,
                sales_term: {
                    unit : state.termUnit,
                    term : state.payTerm,
                },
                base_price: basePrice,
                quantity: orderInfo.quantity,
                volume: orderInfo.volume,
                sub_goods: subGoodsList,
            }

            packageOrderRequestInfo.goods.push(goodsInfo)
        })
        
        return packageOrderRequestInfo
    },
    getTotalPriceWithOutVat : (state, getters) => {
        let orderInfoList = getters.getOrderInfoList
        let subGoodsOrderInfoList = getters.getSubGoodsOrderInfoList
        let totalPrice = 0

        orderInfoList.forEach(orderInfo => {
            totalPrice += orderInfo.priceInfo.price // 정가 : 할인가 origin_price - origin_sub_price
            if(orderInfo.priceInfo.installation_cost){
                totalPrice += orderInfo.priceInfo.installation_cost.price // 설치비

                if(orderInfo.priceInfo.installation_cost.discount_rule){
                    orderInfo.priceInfo.installation_cost.discount_rule.forEach(discountInfo => {
                        if(orderInfo.priceInfo.installation_cost.price>0){
                            totalPrice -= parseInt(discountInfo.sub_price) // 설치비의 도메인 할인
                        }
                    })
                }
            }
        })

        subGoodsOrderInfoList.forEach(subGoodsOrderInfo => {
            totalPrice += subGoodsOrderInfo.priceInfo.price
                * subGoodsOrderInfo.quantity
                * (subGoodsOrderInfo.perVolume ?  (subGoodsOrderInfo.volume / subGoodsOrderInfo.perVolume ) : 1 )
        })
        
        return totalPrice
    },
    getTotalPrice : (state, getters) => {
      return getters.getTotalPriceWithOutVat + getters.getVat
    },
    getVat : (state, getters) => {
        return getters.getTotalPriceWithOutVat * 0.1
    },
    getSubGoodsOrderInfoList : (state, getters) => {
        let orderInfoList = getters.getOrderInfoList
        let subGoodsOrderInfoList = []


        orderInfoList.forEach(orderInfo => {
            let findSubGoodsOrderInfoList = _.chain(state.checkedSubGoodsList)
                .filter(subGoodsInfo => {
                    return parseInt(subGoodsInfo.main_goods_id) === parseInt(orderInfo.id)
                })
                .flatMap(subGoodsInfo => {
                    let mainGoodsTermPriceInfo = state.termPriceList.find(termPriceInfo => {
                        return termPriceInfo.id === subGoodsInfo.main_goods_id
                    })
                    if(!mainGoodsTermPriceInfo){
                        return
                    }

                    let subGoodsTermPriceInfoList = mainGoodsTermPriceInfo.sub_goods.find(loopSubGoodsInfo => {
                        return subGoodsInfo.id === loopSubGoodsInfo.id
                    })
                    if(!subGoodsTermPriceInfoList){
                        return
                    }

                    let subGoodsTermPriceInfo = subGoodsTermPriceInfoList.term_prices.find(subGoodsTermPriceInfo => {
                        return subGoodsTermPriceInfo.term_volume === state.payTerm
                    })
                    if(!subGoodsTermPriceInfo){
                        return
                    }

                    return {
                        id : subGoodsInfo.id,
                        main_goods_id : subGoodsInfo.main_goods_id,
                        quantity : subGoodsInfo.quantity,
                        volume : subGoodsInfo.volume,
                        perVolume : subGoodsInfo.per_volume,
                        volumeUnit : subGoodsInfo.volume_unit,
                        sort : subGoodsInfo.sort,
                        name : subGoodsInfo.name,
                        term_unit : subGoodsInfo.term_unit,
                        priceInfo : subGoodsTermPriceInfo,
                        discount : subGoodsTermPriceInfo.discount_rule
                    }
                })
                .compact()
                .orderBy(subGoodsInfo => {
                    return subGoodsInfo.sort
                }, ['asc'])
                .value()

                subGoodsOrderInfoList = [...subGoodsOrderInfoList, ...findSubGoodsOrderInfoList]
            })

        return subGoodsOrderInfoList
    },
    getOrderInfoList : (state, getters) => {
        let orderInfoList = []
        state.packageGoods.forEach(packageGoodsInfo => {
            let orderInfo = {
                id : null,
                goodsName : null,
                price : null,
                discount : [],
                term : null,
                termUnit : null,
                quantity : null,
                subGoods : [],
                volume : null,
            }
            let priceInfo = getters.getTermPriceByGoodsId(packageGoodsInfo.goods_id)
            if(priceInfo){
                orderInfo.id = parseInt(packageGoodsInfo.goods_id)
                orderInfo.goodsName = packageGoodsInfo.expose_name
                orderInfo.priceInfo = priceInfo
                orderInfo.discount = priceInfo.discount_rule
                orderInfo.term = state.payTerm
                orderInfo.termUnit = state.termUnit
                orderInfo.quantity = 1
                orderInfo.volume = packageGoodsInfo.goods_info.resources[0].volume ?
                                        parseInt(packageGoodsInfo.goods_info.resources[0].volume) : null

                orderInfoList.push(orderInfo)
            }
        })
        
        return orderInfoList
    },
    getTermPriceByGoodsId : state => (packageGoodsId) => {
        let goodsTermPriceInfo = state.termPriceList.find(termPriceInfo => {
            return parseInt(termPriceInfo.id) === parseInt(packageGoodsId)
        })

        if(!goodsTermPriceInfo){
            return false
        }

        return goodsTermPriceInfo.term_prices.find(termPriceInfo => {
            return termPriceInfo.term_volume === state.payTerm
        })
    },
    getSelectedPackageGoodsIdList : state => {
        return _.flatMap(state.packageGoods, (packageGoodsInfo) => {
            return parseInt(packageGoodsInfo.goods_id)
        })
    },
    getSelectedSubGoodsIdList : state => {
        return _.flatMap(state.checkedSubGoodsList, (packageGoodsInfo) => {
            return parseInt(packageGoodsInfo.id)
        })
    },
    getCheckedSubGoodsList : state => {
        return state.checkedSubGoodsList
    },
}

const mutations = {
    setOrderInfo (state, {packageId, payTerm, termUnit}) {
        state['packageId'] = packageId
        state['payTerm'] = payTerm
        state['termUnit'] = termUnit
    },
    setPackageGoods(state, packageGoods) {
        state['packageGoods'] = packageGoods
    },
    setDomain (state, domain) {
        state['domain'] = domain
    },
    setPayTerm (state, payTerm) {
        let addMonthDate = oracleHelper.getAddMonthOracle(new Date(), payTerm)
        state.expireDate = addMonthDate
        
        state['payTerm'] = payTerm
    },
    setCheckedClauseCompositionList(state, idList){
        state['checkedClauseCompositionList'] = idList
    },
    addSubGoods(state, {main_goods_id, id, quantity, volume, cost, per_volume, sort, name, volume_unit, term_unit}){
        state['checkedSubGoodsList'].push({
            main_goods_id: main_goods_id,
            id: id,
            quantity: quantity,
            volume: volume,
            cost: cost,
            per_volume: per_volume,
            sort: sort,
            name: name,
            volume_unit: volume_unit,
            term_unit: term_unit,
        })
    },
    removeSubGoods(state, subGoodsId){
        state['checkedSubGoodsList'] =
            state['checkedSubGoodsList'].filter(function(subGoodsInfo) {
            return subGoodsInfo.id !== subGoodsId
        })
    },
    changeQuantity(state, {id, quantity}){
        let findSubGoodsInfo = state['checkedSubGoodsList'].find((subGoodsInfo)=>{
            return parseInt(subGoodsInfo.id) === parseInt(id)
        })
        if(findSubGoodsInfo){
            findSubGoodsInfo.quantity = quantity
        }
    },
    changeVolume(state, {id, volume}){
        let findSubGoodsInfo = state['checkedSubGoodsList'].find((subGoodsInfo)=>{
            return parseInt(subGoodsInfo.id) === parseInt(id)
        })

        if(findSubGoodsInfo){
            findSubGoodsInfo.volume = volume
        }
    },
    refreshSubGoods(state){
        let packageGoodsId = _.flatMap(state['packageGoods'], (packageGoodsInfo)=>{
            return parseInt(packageGoodsInfo.goods_id)
        })

        if(packageGoodsId.length <= 0){
            return
        }

        state['checkedSubGoodsList'] = state['checkedSubGoodsList'].filter((subGoodsInfo)=>{
            return packageGoodsId.includes(subGoodsInfo.main_goods_id)
        })
    },
    setDomainDiscountRule(state, {domainDiscountRule, mainGoodsId}){
        state.termPriceList.forEach(termPriceInfo => {
            if (termPriceInfo.id === mainGoodsId) {
                termPriceInfo.term_prices.forEach(mainGoodsTermPriceInfo => {
                    mainGoodsTermPriceInfo.installation_cost.discount_rule = domainDiscountRule ? [domainDiscountRule.rule] : []
                })
            }
        })
    },
    setDomainMsg(state, msg){
        state.domainMsg = msg
    },
    setDomainStatus(state, status){
        state.domainStatus = status
    },
    setExpireDate(state, expireDate){
        state.expireDate = expireDate
    },

}

const actions = {
    setOrderInfo({commit}, {packageId, payTerm, termUnit}){
        commit('setOrderInfo', {packageId, payTerm, termUnit})
    },
    setDomain({commit}, domain){
        commit('setDomain', domain)
    },
    changePackageGoods({commit}, packageGoods){
        commit('setPackageGoods', packageGoods)
    },
    addSubGoods({commit}, {main_goods_id, id, quantity, volume, cost, per_volume, sort, name, volume_unit, term_unit}){
        commit('addSubGoods', {main_goods_id, id, quantity, volume, cost, per_volume, sort, name, volume_unit, term_unit})
    },
    removeSubGoods({commit}, subGoodsInfo){
        commit('removeSubGoods', subGoodsInfo)
    },
    changeQuantity({commit}, {id, quantity}){
        commit('changeQuantity', {id, quantity})
    },
    changeVolume({commit}, {id, volume}){
        commit('changeVolume', {id, volume})
    },
    refreshSubGoods({commit}){
        commit('refreshSubGoods')
    },
    setDomainDiscountRule({commit}, {domainDiscountRule, mainGoodsId, msg, flag}){
        commit('setDomainDiscountRule', {domainDiscountRule, mainGoodsId})
        commit('setDomainMsg', msg)
        commit('setDomainStatus', flag)
    },
    setDomainInit({commit}){
        commit('setDomain', null)
        commit('setDomainMsg', null)
    },
    setExpireDate({commit}, expireDate){
        commit('setExpireDate', expireDate)
    },
    orderRequest({getters}){
        let orderRequestInfo = getters.getOrderRequestInfo;

        return wwwHiworksApi.orderRequest(orderRequestInfo)
    },
}

export default {
    namespaced: true,
    state: initialState,
    mutations,
    actions,
    getters,
    strict: process.env.NODE_ENV !== 'production'
}